import React, { useState } from 'react';
import { Form } from 'semantic-ui-react';
import _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../service/apiService';
import StopSearchComponent from '../AssetManagementList/StopDropdown';

const StopComponent = ({ formik }) => {
  const selectedField = _.get(formik, 'values.g_field', '');
  const selectedStopId = _.get(formik, 'values.g_stop', '');
  const [stopList, setStopList] = useState([]);

  React.useEffect(() => {
    async function fetchApi() {
      if (selectedStopId) {
        const response = await ApiService.getAssetsByIds([selectedStopId]);
        if (!_.isEmpty(response)) {
          const stopName = _.get(response[0], 'name', '');
          const stopId = _.get(response[0], 'id', '');
          setStopList([{ key: stopId, value: stopId, text: stopName }]);
        } else toastr.error('Failed to fetch Stop');
      }
    }
    fetchApi();
  }, []);

  const changeSelectedId = (props) => {
    formik.setFieldValue('g_stop', props);
  };

  return (
    <Form.Field>
      <>
        <label>Stop Name</label>
        <StopSearchComponent
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '4px',
            border: 'solid 0.5px #e8e8e8',
          }}
          selectedFieldProps={selectedField}
          selectedStopId={selectedStopId}
          stopList={stopList}
          label={false}
          location="assetMangement"
          disabled={_.isEmpty(selectedField)}
          setSelectedStop={changeSelectedId}
        />
      </>
    </Form.Field>
  );
};

export default StopComponent;
